<template>
  <h1>InputRadialSliderDev</h1>

  <div class="row">
    <input-radial-slider v-model="current" :total="total" />
  </div>

  <div class="row">
    <p><strong>Current value:</strong> {{ current ? current : '(none)' }}</p>
    <p><strong>Has value:</strong> {{ hasValue ? 'True' : 'False' }}</p>
    <button class="btn btn-success" @click="randomizeValue">
      Randomize value
    </button>
  </div>
</template>

<script>
import InputRadialSlider from './InputRadialSlider.vue';
import DevComponentContainer from '../../DevComponent/DevComponentContainer';
import { pickRandom } from '@/utils/arrayUtil';

export default {
  name: 'InputRadialSliderDev',
  components: { InputRadialSlider },
  extends: DevComponentContainer,
  data() {
    return {
      current: 0,
      total: 100,
    };
  },
  computed: {
    hasValue() {
      return this.current;
    },
  },
  methods: {
    randomizeValue() {
      this.current = Math.round(Math.random() * this.total);
    },
  },
};
</script>
